import {
  pinyinDataSchema,
  pinyinSyllableEntrySchema,
  pinyinToneEntrySchema,
  pinyinToneKeyList,
  pinyinToneKeySchema,
  type PinyinData,
  type PinyinDataEntry,
  type PinyinSyllableEntry,
  type PinyinSyllableType,
  type PinyinToneEntry,
  type PinyinToneKey,
} from "#pinyin-data-schema";

export {
  pinyinToneKeyList,
  type PinyinData,
  type PinyinDataEntry,
  type PinyinSyllableEntry,
  type PinyinSyllableType,
  type PinyinToneEntry,
  type PinyinToneKey,
};

export function isPinyinToneKey(key: string): key is PinyinToneKey {
  return pinyinToneKeySchema.safeParse(key).success;
}

export function isPinyinData(value: unknown): value is PinyinData {
  return pinyinDataSchema.safeParse(value).success;
}

export function isPinyinToneEntry(entry: PinyinDataEntry): entry is PinyinToneEntry {
  return pinyinToneEntrySchema.safeParse(entry).success;
}

export function isPinyinSyllableEntry(entry: PinyinDataEntry): entry is PinyinSyllableEntry {
  return pinyinSyllableEntrySchema.safeParse(entry).success;
}

/** Normalize a syllable entry's `term` (which may be a single string, an array of
 * interchangeable mnemonics, or absent) to a flat list of bracket-annotated mnemonic strings.
 * Empty strings are dropped. Returns `[]` when there is no usable term. */
export function getPinyinSyllableTermOptions(entry: PinyinSyllableEntry): string[] {
  const { term } = entry;
  if (term === undefined) {
    return [];
  }
  const list = Array.isArray(term) ? term : [term];
  return list.filter((option) => option !== "");
}

export function getPinyinSyllableEntry(
  data: PinyinData,
  tonelessSyllable: string,
): PinyinSyllableEntry | undefined {
  const entry = data[tonelessSyllable];
  if (entry === undefined || !isPinyinSyllableEntry(entry)) {
    return undefined;
  }
  return entry;
}

export function getPinyinToneEntry(
  data: PinyinData,
  tone: PinyinToneKey,
): PinyinToneEntry | undefined {
  const entry = data[tone];
  if (entry === undefined || !isPinyinToneEntry(entry)) {
    return undefined;
  }
  return entry;
}
